import React from "react";
import {Drawer, SwipeableDrawer, useMediaQuery} from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";
import {setDrawerState, toggleDrawer} from "../../app/app.slice";
import {useDispatch, useSelector} from "react-redux";
import clsx from "clsx";
import config from 'config'

const useStyles = makeStyles((theme) => ({
    drawerPaper: props => ({
        overflow: props.properties.closedCompact ? 'visible' : 'auto',
        background: props.styles.background,
        padding: props.styles.padding,
        borderRight: 0,
        width: props.isOpenDrawer ? props.properties.sidebarOpenWidth ? props.properties.sidebarOpenWidth : 290 : props.properties.closedCompact ? 100 : 0,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
    }),
}))
const SidebarDrawer = ({children, styles, properties}) => {
    const {isOpenDrawer} = useSelector(state => state.app);
    const classes = useStyles({styles, isOpenDrawer, properties});
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:700px)');
    if (isMobile) {
        return (
            <SwipeableDrawer
                classes={{paper: classes.drawerPaper}}
                onClose={() => dispatch(setDrawerState(false))}
                onOpen={() => dispatch(setDrawerState(true))}
                open={isOpenDrawer}
                className={clsx('sb-side-bar-drawer', styles.className)}
            >
                {children}
            </SwipeableDrawer>
        )
    }
    return (
        <Drawer
            classes={{paper: clsx('sb-side-bar-drawer-paper', classes.drawerPaper)}}
            open={isOpenDrawer}
            onClose={() => dispatch(toggleDrawer)}
            variant="permanent"
            className={clsx('sb-side-bar-drawer', styles.className, classes.drawer)}
        >
            {children}
        </Drawer>
    )
}
export default SidebarDrawer;